/* Two calendar weeks in Europe/Bucharest: 2–15 November 2026 inclusive.
 * Presentation only. Product prices and discounts remain Shopify's responsibility.
 */
(() => {
 const start=Date.parse(document.documentElement.dataset.holditBfStart || '2026-11-02T00:00:00+02:00');
 const end=Date.parse(document.documentElement.dataset.holditBfEnd || '2026-11-16T00:00:00+02:00');
 function refresh(){
  const active=document.documentElement.dataset.holditBfReady==='true' && Date.now()>=start && Date.now()<end;
  document.querySelectorAll('[data-holdit-bf]').forEach(el=>{el.hidden=!active;});
  document.querySelectorAll('[data-holdit-evergreen]').forEach(el=>{el.hidden=active;});
 }
 refresh();setInterval(refresh,30000);
 document.addEventListener('shopify:section:load',refresh);
 document.addEventListener('visibilitychange',refresh);
})();
